export const CUSTOM_ICONS: string[] = [
  'analytics',
  'arrow-back',
  'arrow-down',
  'assignment_ind',
  'attendance',
  'banknote-arrow-down',
  'banknote-arrow-up',
  'barcode',
  'bell',
  'billing-and-invoices',
  'cake',
  'calculator',
  'calendar',
  'camera-off',
  'cash-drawer',
  'cash-register',
  'check',
  'check-check',
  'chef-hat',
  'child',
  'circle-check',
  'circle-play',
  'circle-x',
  'clipboard-list',
  'clock',
  'clock-alert',
  'close',
  'company',
  'compliance',
  'copy',
  'cooking-pot',
  'customer',
  'customers',
  'dashboard',
  'discounts',
  'download',
  'error-alert',
  'error',
  'expenses',
  'export',
  'external-link',
  'feature-request',
  'feedback',
  'file-chart-column',
  'file-badge',
  'filter',
  'grip-vertical',
  'id-card',
  'info',
  'inventory',
  'key-round',
  'layers',
  'loading',
  'location',
  'lock',
  'magnifying-glass',
  'mail',
  'mail-open',
  'menu-book',
  'messages-square',
  'mini-expand',
  'minus',
  'motorcycle',
  'my-account',
  'note',
  'online',
  'open-in-new',
  'overdue',
  'package',
  'package-plus',
  'paper-bag',
  'payments',
  'pencil',
  'percent',
  'person',
  'phone',
  'pick-up',
  'picture-as-pdf',
  'plans',
  'plus',
  'printer-settings',
  'printer',
  'products',
  'receipt-text',
  'rotate-ccw-clock',
  'save',
  'scan-barcode',
  'settings',
  'shield',
  'shield-alert',
  'shield-check',
  'shield-off',
  'shopping-cart',
  'side-menu-plans',
  'star',
  'sticky-note',
  'stores',
  'subscriptions',
  'suppliers',
  'support',
  'tag',
  'telephone',
  'text-snippet',
  'three-dots',
  'ticket-check',
  'ticket-x',
  'transactions',
  'trash-mini',
  'trash',
  'trending-down',
  'trending-up',
  'truck',
  'upload-file',
  'upload',
  'utensils',
  'visibility-off',
  'visibility',
  'wallet',
  'wand-sparkles',
  'warn',
];
